// Runtime Profile (see CONTEXT.md): which deployment this frontend build serves.
// `hosted` is the Gaia cloud service; `standalone` is a Standalone Install served
// same-origin by the local backend inside the desktop shell. Chosen at build time
// (`vite build --mode standalone` loads frontend/.env.standalone), so the value is
// a compile-time constant and hosted-only branches drop out of the standalone bundle.

export const RUNTIME_PROFILES = Object.freeze({
  HOSTED: 'hosted',
  STANDALONE: 'standalone',
});

// Compared against the literal (not RUNTIME_PROFILES.STANDALONE) so the bundler
// can constant-fold it and drop the other profile's code.
export const IS_STANDALONE = import.meta.env.VITE_RUNTIME_PROFILE === 'standalone';
